import * as React from "react";
const SvgFiRrHome = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-home_svg__a)">
      <path
        fill="#062147"
        d="m23.121 9.07-7.585-7.587a5.01 5.01 0 0 0-7.072 0L.879 9.07A2.98 2.98 0 0 0 0 11.19v9.817a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V11.19a2.98 2.98 0 0 0-.879-2.12M15 22.006H9v-3.934a3 3 0 0 1 6 0zm7-1a1 1 0 0 1-1 1h-4v-3.934a5 5 0 0 0-10 0v3.934H3a1 1 0 0 1-1-1V11.19c0-.265.106-.519.293-.707L9.878 2.9a3.01 3.01 0 0 1 4.244 0l7.585 7.586c.186.187.291.44.293.704z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-home_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHome;
